import StockVue from '@/components/stock/StockVue'
import StockMap from '@/components/stock/StockMap'
import StockLots from '@/components/stock/StockLots'
import StockPrograms from '@/components/stock/StockProgramVue'

export default [
  {
    path: '/stock',
    name: 'StockVue',
    component: StockVue,
    props: true,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    },
    children: [
      {
        path: 'carte',
        name: 'StockMap',
        component: StockMap,
        meta: {
          parentName: 'StockVue',
          requiresAuth: true
        }
      },
      {
        path: 'programmes',
        name: 'StockPrograms',
        component: StockPrograms,
        meta: {
          parentName: 'StockVue',
          requiresAuth: true
        }
      },
      {
        path: 'lots',
        name: 'StockLots',
        component: StockLots,
        meta: {
          parentName: 'StockVue',
          requiresAuth: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/stockRouter.js